module.exports = __webpack_public_path__ + "static/media/11_topofertas_mobile.eb1980e7.jpg";